var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToggleTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.59693 1.04063C2.72713 1.01399 2.86193 1 3 1H7H13C14.1046 1 15 1.89543 15 3V5V11V13C15 14.1046 14.1046 15 13 15H7H3C1.89543 15 1 14.1046 1 13V11V5V3C1 2.0335 1.68556 1.22713 2.59693 1.04063ZM7 13H13V11H7V13ZM7 9H13V7H7L7 9ZM5 7L5 9H3V7H5ZM7 5H13V3L7 3V5ZM5 3V5H3V3L5 3ZM3 11H5V13H3V11Z",
    fill: "#001A39"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleTable);
export default __webpack_public_path__ + "static/media/Toggle-Table.2a5f8448fcc8de10f6995b20498ebfb9.svg";
export { ForwardRef as ReactComponent };